import React from "react";
import clsx from "clsx";
import isEmpty from "lodash/isEmpty";
import Typography from "@material-ui/core/Typography";
import useDescriptions from "@micado-digital/react-shop/ProductDetail/hooks/useDescriptions";
import useLocals from "@micado-digital/react-ui/hooks/useLocals";
import Local from "@micado-digital/react-ui/components/Local";
import localDE from "../../../locals/de.json";
import localEN from "../../../locals/en.json";
import localIT from "../../../locals/it.json";

import styles from "./Descriptions.styles";

const Descriptions = ({ lang }) => {
	const descriptions = useDescriptions({
		lang,
		exclude: ["label", "short", "standard", "pre-announcement"]
	});
	const css = styles();
	const l = useLocals({
		lang: lang,
		res: {
			de: localDE,
			en: localEN,
			it: localIT
		}
	});

	if (isEmpty(descriptions)) return <></>;

	return (
		<div className={clsx(css.descriptions, "mco-shop-product-detail-descriptions")}>
			<div className={css.container}>
				<div className={css.wrapper}>
					{descriptions?.map(description => {
						const { identifier, description: text, title } = description;

						return (
							<div className={css.item} key={identifier}>
								<Typography
									className={css.title}
									dangerouslySetInnerHTML={{ __html: title }}
								/>
								<div className={css.text} dangerouslySetInnerHTML={{ __html: text }} />
							</div>
						);
					})}
				</div>
			</div>
			<Typography className={css.copyrights} variant="body2">
				<Local identifier="reactShop.productDetail.descriptions.copyrights" l={l} />
			</Typography>
		</div>
	);
};

export default Descriptions;
